import { useQuery } from '@tanstack/react-query';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';
import type { QuestionReportResponse } from '@signalvote/shared';

export function useCampaignQuestionReport() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.analytics.campaignQuestionReport(),
    queryFn: () =>
      apiJson<QuestionReportResponse>(`/api/campaigns/${selectedCampaign!.id}/questions/report`, {
        error: 'Failed to fetch question report',
      }),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
}
